import script from "./vaccinationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./vaccinationPage.vue?vue&type=script&setup=true&lang=js"

import "./vaccinationPage.vue?vue&type=style&index=0&id=624b3940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624b3940"]])

export default __exports__